
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'

import { LocaleModule } from 'common/locale/module'
import { UtilCommonModule } from 'common/util/module'
import { HelpModalComponent } from './components/helpModal.component'

@NgModule({
  imports: [
    CommonModule,
    UtilCommonModule,
    LocaleModule.forChild(),
    FormsModule,
  ],
  declarations: [
    HelpModalComponent,
  ],
})
export class HelpModule { }

export { HelpService } from './services/help.service'
